import { createSlice } from "@reduxjs/toolkit";

// formSlice.js
import { COUNTRIES } from "../../utils/HomepageData";

// Get default countries from Homepage_Data
const DEFAULT_COUNTRY_FROM = COUNTRIES.IN;
const DEFAULT_COUNTRY_TO = COUNTRIES.US;

// formSlice.js
const initialState = {
  countryFrom: JSON.parse(localStorage.getItem('countryFrom')) || DEFAULT_COUNTRY_FROM,
  countryTo: JSON.parse(localStorage.getItem('countryTo')) || DEFAULT_COUNTRY_TO,
  currencyFrom: localStorage.getItem('currencyFrom') || DEFAULT_COUNTRY_FROM.currencies[0],
  currencyTo: localStorage.getItem('currencyTo') || DEFAULT_COUNTRY_TO.currencies[0],
  amount: 10000, // Example default
  amountType: "SENDING", // Example default
};

// Create the slice
const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setCountryFrom: (state, action) => {
      state.countryFrom = action.payload;
    },
    setCountryTo: (state, action) => {
      state.countryTo = action.payload;
    },
    setCurrencyFrom: (state, action) => {
      state.currencyFrom = action.payload;
    },
    setCurrencyTo: (state, action) => {
      state.currencyTo = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = action.payload;
    },
    setAmountType: (state, action) => {
      state.amountType = action.payload;
    },
    setFormData: (state, action) => {
      return { ...state, ...action.payload }; // Corrected to return a new state object
    },
  },
});

// Export actions
export const {
  setCountryFrom,
  setCountryTo,
  setCurrencyFrom,
  setCurrencyTo,
  setAmount,
  setAmountType,
  setFormData,
} = formSlice.actions;

// Export the reducer
export default formSlice.reducer;
